"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _readOnlyError2 = _interopRequireDefault(require("@babel/runtime/helpers/readOnlyError"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _commonI18n = require("@mmc/common-i18n");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _text = require("@mmc/text");
var _linkItem = _interopRequireDefault(require("./link-item"));
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var _lazyNavLinkImage = _interopRequireDefault(require("./lazy-nav-link-image"));
var _lazyNavBackgroundImage = _interopRequireDefault(require("./lazy-nav-background-image"));
// const LazyNavLinkImage = React.lazy(() => require("./lazy-nav-link-image"));
// const LazyNavBackgroundImage = React.lazy(() => require("./lazy-nav-background-image"));

var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray,
  handleNestedProp = dataUtils.handleNestedProp,
  appendImageOptimization = dataUtils.appendImageOptimization,
  formatAsMKSPath = dataUtils.formatAsMKSPath;
var prepareProductForDataLayer = function prepareProductForDataLayer(product, currencyFormat) {
  if (product) {
    var clonedProduct = JSON.parse(JSON.stringify(product));
    if (clonedProduct.cta && clonedProduct.cta.url) {
      clonedProduct.cta.url = formatAsMKSPath(clonedProduct.cta.url);
    }
    if (clonedProduct.price) {
      clonedProduct.price.currency = currencyFormat;
    }
    return clonedProduct;
  }
  return product;
};
var getBackgroundImage = function getBackgroundImage(checkedLink, link) {
  var imageWidth = 480;
  var imageSrc = handleNestedProp(link, 'checkedLink.vehicleBackgroundImage.image');
  var isBackground = false;
  var isWebp = true;
  var imageQuality = 70;
  return checkedLink.vehicleBackgroundImage && (checkedLink.vehicleImage === ' ' || checkedLink.vehicleImage === null || checkedLink.vehicleImage === undefined) && /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].navLinkImage
  }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    src: "" + appendImageOptimization(imageSrc, imageWidth, isBackground, isWebp, imageQuality),
    srcSet: [appendImageOptimization(imageSrc, 320, isBackground, isWebp, imageQuality) + " 320w", appendImageOptimization(imageSrc, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(imageSrc, 640, isBackground, isWebp, imageQuality) + " 640w", appendImageOptimization(imageSrc, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(imageSrc, 1080, isBackground, isWebp, imageQuality) + " 1080w"].join(','),
    sizes: "(min-width: 768px) 30vw, 60vw",
    alt: handleNestedProp(link, 'link.vehicleBackgroundImage.altText'),
    width: imageWidth
  }));
};
var getListClasses = function getListClasses(params) {
  var menuOpen = params.menuOpen,
    theme = params.theme,
    isLast = params.isLast;
  return _navigationHeader["default"].navBtnItem + " " + (menuOpen ? null : theme.grey) + " " + (isLast ? _navigationHeader["default"].lastBtnItem : '') + " menu-panel-top-level-item";
};
var getLength = function getLength(arr) {
  return arr && arr.length;
};
var MenuPanel = /*#__PURE__*/function (_React$Component) {
  function MenuPanel(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var keyHandler = props.keyHandler || _this.keyHandler.bind(_this);
    _this.focusHandler = _this.focusHandler.bind(_this);
    _this.refList = {};
    _this.state = {
      keyHandler: keyHandler
    };
    return _this;
  }
  (0, _inheritsLoose2["default"])(MenuPanel, _React$Component);
  var _proto = MenuPanel.prototype;
  _proto.keyHandler = function keyHandler() {
    var keyHandlerMethod = this.props.keyHandlerMethod;
    keyHandlerMethod.apply(void 0, arguments);
  };
  _proto.focusHandler = function focusHandler() {
    var focusHandler = this.props.focusHandler;
    if (focusHandler !== undefined) {
      focusHandler(true);
    }
  };
  _proto.checkDisclaimerID = function checkDisclaimerID(checkedSettings) {
    var disclaimerID = checkedSettings.disclaimerIdVehicleCard;
    var codeValue = disclaimerID && disclaimerID !== '' ? disclaimerID : handleNestedProp(checkedSettings, 'checkedSettings.priceDisclaimerId');
    return codeValue;
  };
  _proto.publishMenuClickToDataLayer = function publishMenuClickToDataLayer(mainMenu, linkUrl, subMenu, market) {
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'menu_click',
        comp_page: {
          position: 'top menu',
          main_category: mainMenu ? mainMenu.toLowerCase() : null,
          selected_category: subMenu ? subMenu.toLowerCase() : null
        }
      });
      if (['/concesionarios', '/localizador-concessionarios', '/loyda-lahin-jalleenmyyjasi'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'dealer_locator_click',
          comp_page: {
            position: 'top menu'
          }
        });
      }
      if (['/comprar/configurador', '/loquiero/configurador', '/osta/rakenna-oma-mitsubishi', '/osta/rakenna-oma-mitsubishi/rakenna-autosi'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'car_configuration_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            color: null,
            upholstery: null,
            accesories: null,
            fuel_type: null,
            price: null,
            currency: null
          }
        });
      }
      if (['/servicio/citataller', '/omistajuus/varaa-huolto'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'maintenance_request_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
      if (['/prueba', '/test-drive', '/varaa-koeajo'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'test_drive_request_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
    }
    if (market.toLowerCase() === 'nl' && typeof window !== 'undefined' && window.dataLayer) {
      if (['/aanschaf/financiering'].includes(linkUrl)) {
        window.dataLayer.push({
          event: 'financingApplication',
          location: 'header_menu'
        });
      }
    }
  };
  _proto.formatNoDropDown = function formatNoDropDown(noDropDown) {
    if (noDropDown === 'true') {
      return true;
    } else {
      return false;
    }
  };
  _proto.renderOverviewLink = function renderOverviewLink(linkData) {
    var checkedLink = {
      url: handleNestedProp(linkData, 'linkData.url'),
      label: handleNestedProp(linkData, 'linkData.label')
    };
    var theme = this.props.theme;
    var keyHandler = this.state.keyHandler;
    return /*#__PURE__*/_react["default"].createElement(_linkItem["default"], {
      key: checkedLink.url,
      url: checkedLink.url,
      classes: ['navOverviewLink'],
      keyHandler: keyHandler,
      theme: theme
    }, checkedLink.label, /*#__PURE__*/_react["default"].createElement("img", {
      className: _navigationHeader["default"].navArrow,
      alt: "nav_arrow",
      src: "data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 4.532L1.41 0 0 1.395l6 5.938 6-5.938L10.59 0z' fill='%23C8C8C8' fill-rule='evenodd'/%3E%3C/svg%3E"
    }));
  };
  _proto.renderProductLink = function renderProductLink(settings) {
    var _this2 = this;
    var checkedSettings = {
      link: handleNestedProp(settings, 'settings.link'),
      i: handleNestedProp(settings, 'settings.i'),
      totalSetSize: handleNestedProp(settings, 'settings.totalSetSize'),
      name: handleNestedProp(settings, 'settings.name'),
      addPriceDisclaimer: handleNestedProp(settings, 'settings.addPriceDisclaimer'),
      priceDisclaimerId: handleNestedProp(settings, 'settings.priceDisclaimerId'),
      disclaimerData: settings.disclaimerData,
      enableProductsRatingStars: handleNestedProp(settings, 'settings.link.enableProductsRatingStars'),
      productSkuId: handleNestedProp(settings, 'settings.link.productSkuId'),
      disclaimerIdVehicleCard: handleNestedProp(settings, 'settings.link.disclaimerIdVehicleCard'),
      market: handleNestedProp(settings, 'settings.market')
    };
    var link = checkedSettings.link,
      enableProductsRatingStars = checkedSettings.enableProductsRatingStars,
      productSkuId = checkedSettings.productSkuId;
    var checkedLink = {
      vehicleBackgroundImage: handleNestedProp(link, 'link.vehicleBackgroundImage'),
      vehicleImage: handleNestedProp(link, 'link.vehicleImage'),
      price: handleNestedProp(link, 'link.price'),
      cta: handleNestedProp(link, 'link.cta'),
      label: handleNestedProp(link, 'link.name'),
      openNewTab: handleNestedProp(link, 'link.cta.openNewTab')
    };
    var label = checkedLink.label === ' ' || checkedLink.label === null || checkedLink.label === undefined ? handleNestedProp(link, 'link.cta.label') : checkedLink.label;
    var setSize = checkedSettings.totalSetSize;
    var posInSet = checkedSettings.i + 1;
    var name = checkedSettings.name + "_" + label;
    var _this$props = this.props,
      theme = _this$props.theme,
      config = _this$props.config;
    this.refList[name] = this.refList[name] || {};
    var market = checkedSettings.market;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: label + "-" + checkedSettings.i,
      className: _navigationHeader["default"].navProductLink + " " + theme['col-xs-12'] + " " + theme['col-sm-4'] + " " + theme['col-md-3'] + " menu-panel-sub-list-item",
      ref: function ref(el) {
        _this2.refList[name][checkedSettings.i] = el;
        return el;
      },
      onKeyUp: function onKeyUp(e) {
        return _this2.keyHandler(e, checkedSettings.i, _this2.refList[name][checkedSettings.i]);
      },
      role: "menuitem",
      "aria-setsize": setSize,
      "aria-posinset": posInSet,
      "data-menu-item-name": name,
      "data-menu-item-parent-name": checkedSettings.name
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: "" + handleNestedProp(link, 'link.cta.url'),
      onClick: function onClick() {
        return _this2.publishMenuClickToDataLayer(checkedSettings.name, handleNestedProp(link, 'link.cta.url'), label, market);
      },
      "data-section": checkedSettings.name,
      "data-linkindex": checkedSettings.i,
      title: label,
      target: checkedLink.cta.openNewTab ? '_blank' : '',
      rel: "noreferrer"
    }, checkedLink.vehicleImage && /*#__PURE__*/_react["default"].createElement(_lazyNavLinkImage["default"], {
      checkedLink: checkedLink
    }), getBackgroundImage(checkedLink, link), /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].navLinkInfo
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _navigationHeader["default"].navLinkLabel + " " + theme.navCarSelector
    }, label), enableProductsRatingStars && /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].feefoWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "feefo-product-stars-widget",
      "data-product-sku": productSkuId
    })), checkedLink.price ? /*#__PURE__*/_react["default"].createElement("p", {
      className: _navigationHeader["default"].navLinkPrice + " " + theme.bodyCopy
    }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: handleNestedProp(checkedLink, 'checkedLink.price.value'),
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode'),
        displayValue: handleNestedProp(checkedLink, 'checkedLink.price.displayValue'),
        zeroMessage: handleNestedProp(checkedLink, 'checkedLink.price.zeroMessage')
      },
      addPriceDisclaimer: handleNestedProp(checkedSettings, 'checkedSettings.addPriceDisclaimer'),
      priceDisclaimerId: this.checkDisclaimerID(checkedSettings),
      disclaimerData: checkedSettings.disclaimerData
    })) : config.market === 'language-masters' && /*#__PURE__*/_react["default"].createElement("p", {
      className: _navigationHeader["default"].navLinkPrice + " " + theme.bodyCopy
    }, "From $XX,XXX.XX"))));
  };
  _proto.renderItemLink = function renderItemLink(settings) {
    var _this3 = this;
    var checkedSettings = {
      link: handleNestedProp(settings, 'settings.link'),
      i: handleNestedProp(settings, 'settings.i'),
      totalSetSize: handleNestedProp(settings, 'settings.totalSetSize'),
      name: handleNestedProp(settings, 'settings.name'),
      market: handleNestedProp(settings, 'settings.market')
    };
    var link = checkedSettings.link;
    var market = checkedSettings.market;
    var checkedLink = {
      label: handleNestedProp(link, 'link.label'),
      url: handleNestedProp(link, 'link.url'),
      openNewTab: handleNestedProp(link, 'link.openNewTab')
    };
    var setSize = checkedSettings.totalSetSize;
    var posInSet = checkedSettings.i + 1;
    var name = checkedSettings.name + "_" + checkedLink.label;
    var twoCols = settings.displayNavInTwoColumns === true ? settings.displayNavInTwoColumns : false;
    var _this$props2 = this.props,
      theme = _this$props2.theme,
      products = _this$props2.products;
    this.refList[name] = this.refList[name] || {};
    var twoColClass = '';
    if (twoCols) {
      twoColClass = checkedSettings.i % 2 !== 0 ? theme['col-sm-5'] + " " + theme['col-md-4'] + " " + theme['col-lg-3'] : theme['col-sm-offset-2'] + " " + theme['col-md-offset-4'] + " " + theme['col-lg-offset-6'] + " " + theme['col-sm-5'] + " " + theme['col-md-4'] + " " + theme['col-lg-3'];
    }
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: checkedLink.label + "-" + checkedSettings.i,
      className: _navigationHeader["default"].navItemLink + " " + theme['col-xs-12'] + " " + (twoCols ? twoColClass : theme['col-sm-offset-8']) + " menu-panel-sub-list-item",
      ref: function ref(el) {
        _this3.refList[name][checkedSettings.i] = el;
        return el;
      },
      onKeyUp: function onKeyUp(e) {
        return _this3.keyHandler(e, checkedSettings.i, _this3.refList[name][checkedSettings.i]);
      },
      role: "menuitem",
      "aria-setsize": setSize,
      "aria-posinset": posInSet,
      "data-menu-item-name": name,
      "data-menu-item-parent-name": checkedSettings.name
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: _navigationHeader["default"].dropDownLinkAnchor,
      href: "" + checkedLink.url,
      "data-section": checkedSettings.name,
      target: checkedLink.openNewTab ? '_blank' : '',
      onClick: function onClick() {
        return _this3.publishMenuClickToDataLayer(checkedSettings.name, checkedLink.url, checkedLink.label, market);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _navigationHeader["default"].navLinkLabel + " " + (products && products.length > 0 ? theme.buttonsAndNav : theme.introCopy)
    }, checkedLink.label)));
  };
  _proto.renderProducts = function renderProducts(params) {
    var _this4 = this;
    var products = params.products,
      theme = params.theme,
      totalSetSize = params.totalSetSize,
      name = params.name,
      addPriceDisclaimer = params.addPriceDisclaimer,
      priceDisclaimerId = params.priceDisclaimerId,
      disclaimerData = params.disclaimerData,
      market = params.market;
    return !isEmptyArray(products) && products !== ' ' && /*#__PURE__*/_react["default"].createElement("ul", {
      className: _navigationHeader["default"].navLinkList + " " + theme.row
    }, products.map(function (link, i) {
      return _this4.renderProductLink({
        link: link,
        i: i,
        totalSetSize: totalSetSize,
        name: name,
        addPriceDisclaimer: addPriceDisclaimer,
        priceDisclaimerId: priceDisclaimerId,
        disclaimerData: disclaimerData,
        market: market
      });
    }));
  };
  _proto.renderLinks = function renderLinks(params) {
    var _this5 = this;
    var theme = this.props.theme;
    var links = params.links,
      reducedHeight = params.reducedHeight,
      totalSetSize = params.totalSetSize,
      name = params.name,
      displayNavInTwoColumns = params.displayNavInTwoColumns,
      market = params.market;
    return !isEmptyArray(links) && links !== ' ' && /*#__PURE__*/_react["default"].createElement("ul", {
      className: _navigationHeader["default"].navLinkList + " " + _navigationHeader["default"].linksList + " " + (reducedHeight ? _navigationHeader["default"].reduced : '') + " " + (displayNavInTwoColumns === true ? "" + theme.row : '')
    }, links.map(function (link, i) {
      return _this5.renderItemLink({
        link: link,
        i: i,
        totalSetSize: totalSetSize,
        name: name,
        displayNavInTwoColumns: displayNavInTwoColumns,
        market: market
      });
    }));
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      name = _this$props3.name,
      noDropDown = _this$props3.noDropDown,
      keyHandler = _this$props3.keyHandler,
      clickHandler = _this$props3.clickHandler,
      activeNav = _this$props3.activeNav,
      backgroundImage = _this$props3.backgroundImage,
      addPriceDisclaimer = _this$props3.addPriceDisclaimer,
      priceDisclaimerId = _this$props3.priceDisclaimerId,
      disclaimerData = _this$props3.disclaimerData,
      setSize = _this$props3.setSize,
      posInSet = _this$props3.posInSet,
      menuOpen = _this$props3.menuOpen,
      isLast = _this$props3.isLast,
      theme = _this$props3.theme,
      links = _this$props3.links,
      products = _this$props3.products,
      displayNavInTwoColumns = _this$props3.displayNavInTwoColumns,
      market = _this$props3.market; // eslint-disable-line

    var formatedDropDown = this.formatNoDropDown(noDropDown);
    var id = name.toLowerCase();
    var layout = products.length > 0 ? 'products' : 'feature';
    var linkSetSize = getLength(links) ? links.length : 0;
    var productSetSize = getLength(products) ? products.length : 0;
    var totalSetSize = linkSetSize + productSetSize;
    var expanded = activeNav === id && menuOpen;
    var hasPopUp = !!(linkSetSize || productSetSize);
    var reducedHeight = !(links.length > 0 && products.length === 0);
    if (formatedDropDown) {
      var _links$, _links$2;
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: getListClasses({
          menuOpen: menuOpen,
          theme: theme,
          isLast: isLast
        }),
        role: "menuitem",
        "aria-expanded": expanded,
        "aria-setsize": setSize,
        "aria-posinset": posInSet,
        "aria-haspopup": hasPopUp,
        "data-menu-item-name": name
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: (_links$ = links[0]) == null ? void 0 : _links$.url,
        className: "" + _navigationHeader["default"].navBtnAnchor,
        target: (_links$2 = links[0]) != null && _links$2.openNewTab ? '_blank' : ''
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: _navigationHeader["default"].navBtn + " " + theme.lowIcon + " " + theme.mmcIconDisabled + " " + theme.mmcIconDisabled.mmcIconChevronDown,
        onKeyDown: keyHandler,
        onFocus: this.focusHandler,
        type: "button"
      }, name), /*#__PURE__*/_react["default"].createElement("div", {
        className: _navigationHeader["default"].navPanel + " " + _navigationHeader["default"][layout] + " " + (_navigationHeader["default"][id] ? _navigationHeader["default"][id] : '')
      })));
    } else {
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: getListClasses({
          menuOpen: menuOpen,
          theme: theme,
          isLast: isLast
        }),
        role: "menuitem",
        "aria-expanded": expanded,
        "aria-setsize": setSize,
        "aria-posinset": posInSet,
        "aria-haspopup": hasPopUp,
        "data-menu-item-name": name
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: _navigationHeader["default"].navBtn + " " + theme.lowIcon + " " + theme.mmcIconChevronDown,
        onKeyDown: keyHandler,
        onFocus: this.focusHandler,
        onClick: clickHandler,
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement("span", null, name)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _navigationHeader["default"].navPanel + " " + _navigationHeader["default"][layout] + " " + (_navigationHeader["default"][id] ? _navigationHeader["default"][id] : '')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _navigationHeader["default"].innerLinkContainer + " " + (displayNavInTwoColumns === true ? _navigationHeader["default"].displayNavInTwoColumns : '')
      }, backgroundImage && backgroundImage.image && /*#__PURE__*/_react["default"].createElement(_lazyNavBackgroundImage["default"], {
        backgroundImage: backgroundImage
      }), this.renderProducts({
        products: products,
        theme: theme,
        totalSetSize: totalSetSize,
        name: name,
        addPriceDisclaimer: addPriceDisclaimer,
        priceDisclaimerId: priceDisclaimerId,
        disclaimerData: disclaimerData,
        market: market
      }), this.renderLinks({
        links: links,
        reducedHeight: reducedHeight,
        totalSetSize: totalSetSize,
        name: name,
        displayNavInTwoColumns: displayNavInTwoColumns,
        market: market
      }))));
    }
  };
  return MenuPanel;
}(_react["default"].Component);
MenuPanel.displayName = 'MenuPanel';
MenuPanel.defaultProps = {
  links: [],
  products: []
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(MenuPanel);